// extracted by mini-css-extract-plugin
export default {"profileLoadingSlot":"Profile_profileLoadingSlot__tSREA","profileSpinnerWrap":"Profile_profileSpinnerWrap__qTAr-"};